import * as React from 'react';
export const swishSvg = React.forwardRef(function swishSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.552 15.22a8.005 8.005 0 0 0 10-2.63 7.998 7.998 0 0 0-1.409-10.717l-2.25 2.68a6.248 6.248 0 0 1 .77 8.804 6.394 6.394 0 0 1-4.93 2.278 6.104 6.104 0 0 1-2.181-.415ZM8.008 0a7.97 7.97 0 0 1 3.442.779A6.077 6.077 0 0 0 9.563.373a6.394 6.394 0 0 0-5.224 2.27 6.248 6.248 0 0 0 .77 8.804l-2.251 2.68A7.998 7.998 0 0 1 8.008 0Z',
    }),
  );
});
swishSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var swish = {
  category: 'paymentmethod',
  colorable: true,
  name: 'swish',
  svg: swishSvg,
};
